// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GJH1D","controls":"styles_controls__1HU4f","charLimit":"styles_charLimit__eQeEo","input":"styles_input__m5n8D","send":"styles_send__1cxDc"};